import {
    ADDONS_PAGE_URL,
    BARRINGS_PAGE_URL,
    BROADBAND_ESHOP_URL,
    CANCEL_BROADBAND_PAGE_URL,
    MANAGE_SIM_URL,
    ORDERS_PAGE_URL,
    PORTIN_PAGE_URL,
} from "@constants";
import { i18n } from "@translations/i18n";
import { ITagProps } from "@common/CardWithTitle/Tag";
import {
    EStatus,
    IBroadbandSubscription,
    IMobileSubscription,
} from "@pages/AccountDetails/interface/IAccountDetailsPage";
import { UseTranslationResponse } from "react-i18next";
import { isESimStatusActivated } from "@utils/esim";

export const getAccountDetailsMenu = (broadbandSubscription?: IBroadbandSubscription) => {
    const menuItems = [];

    menuItems.push(
        {
            isBlockedIfNoService: true,
            title: i18n.t("sim:replaceActivateSim"),
            url: MANAGE_SIM_URL,
        },
        {
            externalUrl: process.env.ESHOP_URL,
            isBlockedIfNoService: false,
            title: i18n.t("accountDetails:buyNewSIM"),
        },
        {
            isBlockedIfNoService: true,
            title: i18n.t("accountDetails:moveNumber"),
            url: PORTIN_PAGE_URL,
        },
        {
            isBlockedIfNoService: false,
            title: i18n.t("order:myOrders"),
            url: ORDERS_PAGE_URL,
        },
        {
            isBlockedIfNoService: true,
            title: i18n.t("barrings:barMobileServices"),
            url: BARRINGS_PAGE_URL,
        }
    );

    if (broadbandSubscription?.status === EStatus.ACTIVE) {
        menuItems.push(
            {
                isBlockedIfNoService: false,
                title: i18n.t("accountDetails:addModifyAddOns"),
                url: ADDONS_PAGE_URL,
            },
            {
                isBlockedIfNoService: false,
                title: i18n.t("accountDetails:cancelBroadband"),
                url: CANCEL_BROADBAND_PAGE_URL,
            }
        );
    } else if (!broadbandSubscription) {
        menuItems.push({
            externalUrl: BROADBAND_ESHOP_URL,
            isBlockedIfNoService: false,
            title: i18n.t("accountDetails:buyBroadband"),
        });
    }

    return menuItems;
};

export const getSubscriptionTags = (
    isMobileDomain: boolean,
    subscription: IMobileSubscription & IBroadbandSubscription,
    t: UseTranslationResponse<["accountDetails"]>["t"]
): ITagProps[] | undefined => {
    const { eSim, terminationRequestScheduledAt } = subscription;
    const tags: ITagProps[] = [];

    if (terminationRequestScheduledAt) {
        tags.push({
            label: t("accountDetails:cancellationRequested"),
            variant: "error",
        });
    }

    if (isMobileDomain && eSim && !isESimStatusActivated(eSim)) {
        tags.push({
            label: t("accountDetails:eSimActivate"),
            variant: "success",
        });
    }

    return tags.length > 0 ? tags : undefined;
};
